export default (function (value) {
  return value.length === 0;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isEmpty.js
// module id = 1002
// module chunks = 2